export enum Erp {
    SIFACO = 1,
    SIAF = 2,
    NETFARMA = 3,
    ZETTI = 4,
    DOKA = 5,
    SUTERH = 6,
    GESTOR = 41,
}
